<template>
  <div id="app2" class="home">
    <el-row style="background: #fff;">
      <!-- 年报表 -->
      <el-col :span="4" v-show="flag" class="lefted">
        <!-- <span class="el-icon-d-arrow-left" v-show="flag" @click="
				   flag = !flag;
                    num = 24;
			"></span> -->
        <!-- 切换设备或者目录 -->
        <div class="switch">
          <div :class="['switch-equipment' ,{'active':activeIndex==1}]" @click="activeIndex = 1">设备变量</div>
          <div :class="['switch-record' ,{'active':activeIndex==2}]" @click="recordFun">操作记录</div>
        </div>
        <!-- 设备变量 -->
        <div class="equipment" v-show="activeIndex == 1">
          <!-- 选择企业 -->
          <div class="screen-type ">
            <div class="select-enterprise" @click="shouMenu = true">
              {{enterpriseName}}
            </div>

          </div>
          <div class="unitMenu" v-show="shouMenu" @mouseenter="shouMenu = true" @mouseleave="shouMenu = false">
            <div class="elUnitTreeBody">
              <el-scrollbar style="width: 100%;">
                <el-tree :data="dataList" :expand-on-click-node="false" node-key="id" :props="defaultProps"
                  :highlight-current='true' default-expand-all :filter-node-method="filterNode" ref="tree"
                  @node-click="enterpriseNodeClick">
                  <span class="custom-tree-node" slot-scope="{node, data}">
                    <img src="../../../../public/static/image/elTree/1.9.png" />
                    <span style="padding-left: 5px;">{{node.label}}</span>
                  </span>
                </el-tree>
              </el-scrollbar>
            </div>
          </div>
          <!-- 筛选类型 -->
          <div class="screen-type">
            <el-select v-model="screenTypevalue" placeholder="选择类型">
              <el-option v-for="item in screenTypeData" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>

          <div class="shengcheng" style="position: absolute;right: 17px;">
            <el-button type="primary" size="mini" @click="baobiao">批量增加</el-button>
          </div>
          <div style="margin-bottom:10px;margin-left:13px;height: 30px;line-height: 30px;">设备列表</div>
          <el-tree class="filter-tree" :data="treeList" show-checkbox node-key="Content.Name" :props="defaultProps2"
            :filter-node-method="filterNode" @check="currentChecked" @node-click="handleNodeClick"
            style="height: 100%;overflow-y: scroll;max-height: 750px;max-width:100%" ref="tree">
            <span class="custom-tree-node" slot-scope="{node, data}">

              <span style="padding-left: 5px;">{{data.Content.Name}}</span>
            </span>
          </el-tree>
        </div>
        <!-- 操作记录 -->
        <div class="record" v-show="activeIndex == 2">
          <el-tree class="filter-tree" :data="recordList" node-key="temName" :props="defaultProps3"
            :filter-node-method="filterNode" :load="loadNode" lazy @node-click="recordTreeClick"
            style="height: 100%;overflow-y: scroll;max-height: 750px;max-width:100%" ref="tree">
            <span class="custom-tree-node" slot-scope="{node, data}">
              <img src="../../../../public/static/image/elTree/1.9.png" style="margin-right: 5px;" />
              <!-- <img src="../../../../public/static/image/elTree/2.1.png" style="margin-right: 5px;" /> -->
              <span style="padding-left: 5px;">{{data.temName}}</span>
            </span>
          </el-tree>
        </div>
      </el-col>
      <el-col :span="num" class="righted">
        <span class="el-icon-d-arrow-right" v-show="!flag" @click="flag=!flag;num=19;"></span>
        <!-- 
				<el-form :inline="true" :model="search" ref="search" :rules="rules" class="demo-form-inline">
					<el-form-item label="报表:" prop="name">
						<el-input v-model="search.name" placeholder="点击树形选择" readonly class="noborder"></el-input>
					</el-form-item>
					<el-form-item label="查询时间:" prop="date">
						<el-date-picker style="margin: 0 10px;" v-model="search.date"  type="datetime" placeholder="选择日期时间"
							align="right" :picker-options="pickerOptions"></el-date-picker>
					</el-form-item>

					<el-form-item label="是否传入:">
						<el-checkbox v-model="search.isAfferentTime">传入时间</el-checkbox>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onSubmit(1)" v-waves>查询</el-button>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onSubmit(2)" v-waves>导出</el-button>
					</el-form-item>
					<el-form-item>
						<input style="font-size:16px;" type="file" id="Luckyexcel-demo-file" name="Luckyexcel-demo-file"
							@change="demoHandler" />
					</el-form-item>

				</el-form> -->
        <div class="choice">
          <div class="surface-type">
            <div class="type">
              表类型：<el-select v-model="valueType" placeholder="请选择">
                <el-option v-for="item in optionsType" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="timer">
              <div class="block">
                <span class="demonstration">查询类型：</span>
                <el-select v-model="valueTime" placeholder="请选择">
                  <el-option v-for="item in optionsTime" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>

              </div>
            </div>
            <!-- 具体时间日月年 -->
            <div class="specific-timer">
              起始时间：
              <!-- 年 -->
              <el-date-picker v-model="specificTime" type="year" placeholder="选择年" v-show="valueTime == 'YEAR'">
              </el-date-picker>
              <!-- 月 -->
              <el-date-picker v-show="valueTime == 'MON'" v-model="specificTime" align="right" type="date"
                placeholder="选择月份" :picker-options="pickerOptions">
              </el-date-picker>
              <!-- 日 -->
              <el-date-picker v-show="valueTime == 'DAY'" v-model="specificTime" type="datetime" placeholder="选择日期时间"
                align="right" :picker-options="pickerOptions">
              </el-date-picker>

            </div>

          </div>
          <div class="value-type">
            变量名称：<input type="text" style="height:25px">
            值类型：
            <el-radio-group v-model="radio">
              <el-radio :label="0">原值</el-radio>
              <el-radio :label="1">差值</el-radio>
            </el-radio-group>
          </div>
          <div class="column-type">
            <span>列定义：</span> <el-checkbox-group v-model="checkList">
              <el-checkbox label="最大值"></el-checkbox>
              <el-checkbox label="最小值"></el-checkbox>
              <el-checkbox label="平均值"></el-checkbox>
              <el-checkbox label="最大值时间"></el-checkbox>
              <el-checkbox label="最小值时间"></el-checkbox>
            </el-checkbox-group>
          </div>
          <div style="position: absolute;right: 40px;top: 20px;">
            <el-button type="primary" size="small" @click="addExcel_fn">保存记录</el-button>

            <el-button type="primary" size="small" @click="queryExcel_fn">获取数据</el-button>
            <!-- <el-button type="primary" size="small" @click="bbb">获取数据</el-button> -->

            <el-button type="primary" size="small" @click="downloadExcel">文档导出</el-button>
            <!-- <input style="font-size:16px;" type="file" @change="uploadExcel" /> -->
            <!-- <input style="font-size:16px;" type="file" id="Luckyexcel-demo-file" name="Luckyexcel-demo-file"
							@change="demoHandler" /> -->

          </div>
        </div>


        <div id="luckysheet"
          style="height: calc(100vh - 200px);width: 100%;transform: translateY(-14px); margin-top:10px"></div>
      </el-col>
    </el-row>

    <!-- 新增修改保存弹窗 -->
    <el-dialog v-dialogDrag title="" :close-on-click-modal='false' :visible.sync="dialogVisible" width="400" center>
      <div class="top-tree">
        <el-tree class="filter-tree" :data="recordList" node-key="temName" :props="defaultProps3" :load="loadNode" lazy
          :filter-node-method="filterNode" style="overflow-y: scroll;max-height: 400px;min-height: 400px;max-width:100%"
          @node-click="diaTreeClick" ref="tree">
          <span class="custom-tree-node" slot-scope="{node, data}">
            <img src="../../../../public/static/image/elTree/1.9.png" style="margin-right: 5px;" />
            <span style="padding-left: 5px;">{{data.temName}}</span>
          </span>
        </el-tree>
      </div>
      <div class="dia-input" v-show="diaFlag">
        <input type="text" placeholder="请输入名称" v-model="dioName">
        <el-button :type="dioBtn=='修改'?'warning':'primary'" size="small"
          @click="inputBtn(dioBtn)">{{dioBtn}}</el-button>
      </div>
      <div class="dia-input btnss">
        <el-button type="primary" size="medium" @click="diaBtnFun('add')">新增目录</el-button>
        <el-button type="warning" size="medium" @click="diaBtnFun('edit')" :disabled="Btndisabled">修改名称</el-button>
        <el-button type="danger" size="medium" @click="diaBtnFun('del')" :disabled="Btndisabled">删除</el-button>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <!-- <el-button @click="dialogVisible = true">新增</el-button> -->
          <el-button type="primary" size="medium" @click="diaBtnFun('save')" :disabled="Btndisabled">保存操作记录</el-button>
          <!-- edit_fn -->
          <!-- add_fn -->
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
  // import { GetExcelTemplateDirectorieXlsx } from "@/utils/request";
  import {GetExcelTemplateDirectorieXlsx,getUnitTree} from "../../../api/abbNewApi";
  import {statementVariableTree,statementAppTypeGroup,statementSave,statementFindById,statementFindTree,statementfindDataByCatalogueId,statementDeleteById,statementVariableData} from "../../../api/newReport";
  import LuckyExcel from "luckyexcel";
  import $ from 'jquery';
  import axios from 'axios'
  // import { exportExcel } from "@/utils/export"; /*导出*/
  import {parseTime} from "@/utils";
  import waves from '../../../components/module/directive/waves' // waves directive
  import elRadioTree from '@/components/module/tree/elRadioTree.vue'
  import tagsView from "./tagsView"
  import {testaaa,exportExcel} from './export'
  export default {
    directives: {waves},
    components: {
      elRadioTree
    },
    data () {
      var validateName=(rule,value,callback) => {

        if(!value) {
          callback(new Error('请点击左侧树形选择报表'));
          this.$message.info('请点击左侧树形选择报表')
        } else {
          callback();
        }
      };
      return {
        diaFlag: false,//弹窗输入框显示隐藏
        dialogVisible: false,//弹窗
        Btndisabled: true,//按钮禁用
        dioName: "",//弹窗输入框
        dioBtn: "新增",//弹窗输入框右边按钮
        shouMenu: false, //选择企业显示隐藏
        activeIndex: 1, //高亮选项卡
        checkList: [],
        radio: 3, //值类型
        //横向纵向
        optionsType: [{
          value: '选项1',
          label: '横向'
        },{
          value: '选项2',
          label: '纵向'
        }],
        //日月年
        optionsTime: [{
          value: 'DAY',
          label: '日'
        },{
          value: 'MON',
          label: '月'
        },{
          value: 'YEAR',
          label: '年'
        }],
        valueType: '横向',//表类型
        valueTime: 'YEAR',//时间
        specificTime: "", //具体时间
        //选择月份时间选择器
        pickerOptions: {
          disabledDate (time) {
            return time.getTime()>Date.now();
          },
          shortcuts: [{
            text: '今天',
            onClick (picker) {
              picker.$emit('pick',new Date());
            }
          },{
            text: '昨天',
            onClick (picker) {
              const date=new Date();
              date.setTime(date.getTime()-3600*1000*24);
              picker.$emit('pick',date);
            }
          },{
            text: '一周前',
            onClick (picker) {
              const date=new Date();
              date.setTime(date.getTime()-3600*1000*24*7);
              picker.$emit('pick',date);
            }
          }]
        },
        thisId: '',
        search: {
          date: new Date(),
          isAfferentTime: true
        },
        pickerOptions: {
          disabledDate (time) {
            return time.getTime()>Date.now();
          },
          shortcuts: [{
            text: '今天',
            onClick (picker) {
              picker.$emit('pick',new Date());
            }
          },{
            text: '昨天',
            onClick (picker) {
              const date=new Date();
              date.setTime(date.getTime()-3600*1000*24);
              picker.$emit('pick',date);
            }
          },{
            text: '一周前',
            onClick (picker) {
              const date=new Date();
              date.setTime(date.getTime()-3600*1000*24*7);
              picker.$emit('pick',date);
            }
          }]
        },
        value2: '',
        rules: {
          name: [
            {validator: validateName,trigger: 'blur'}
          ],
          date: [
            {required: true,message: '请选择时间',trigger: 'change'}
          ],

        },
        options: {
          container: "luckysheet",
          title: "exceledit", //表 头名
          lang: "zh", //中文
          showtoolbar: true, //是否显示工具栏
          showinfobar: false, //是否显示顶部信息栏
          showsheetbar: false, //是否显示底部sheet按钮
          myFolderUrl: "/",//作用：左上角<返回按钮的链接
          column: 30,
          row: 100,
          allowEdit: true,//是否允许前端编辑
          cellRightClickConfig: {//自定义配置单元右键菜单
            copy: true, // 复制
            copyAs: true, // 复制为
            paste: true, // 粘贴
            insertRow: true, // 插入行
            insertColumn: true, // 插入列
            deleteRow: true, // 删除选中行的数据 
            deleteColumn: true, // 删除选中列的数据
            deleteCell: true,
            hideRow: true,
            hideColumn: true,
            rowHeight: true, // 设置行高
            columnWidth: true, // 设置行宽
            clear: true, // 清空选定内容
            matrix: false, //矩阵 
            sort: false, // 排序
            filter: false, //筛选 
            chart: false, //图表生成
            image: false, //插入图片
            link: false, // 插入连接，比如网址之类
            data: false, //数据校验
            cellFormat: false //设置单元格格式，锁定单元格格式，隐藏公示等
          },
        },
        num: 20,
        //设备变量树形结构
        treeList: [],
        //操作记录树形结构
        recordList: [],
        flag: true,//显示树形
        filterText: '',
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        defaultProps2: {
          children: 'ChildDatas',
          label: 'Content.Name'
        },
        defaultProps3: {
          children: 'children',
          label: 'temName',
        },
        enterpriseID: "",//企业树形id
        enterpriseName: "-- 选择企业 --",
        screenTypeData: null,
        screenTypevalue: "",
        treeListCopy: null,
        checkedNodes: [],
        halfCheckedNodes: null,
        recordId: "",
        treeName: "",
        leftRecordId: "",
        leftRecordName: "",
        dataFlag: false, //判断选中的是否是操作记录
        treeClickCount: 0, //判断树形结构是否双击
        dataOneConunt: 0,//判断第一次添加变量是在哪一位置
        Onecolumn: 0,//第一次出现的位置
      };
    },
    watch: {
      //筛选类型
      screenTypevalue (val) {
        this.screenType_fn(val)
        // this.$refs.tree.filter(val);
      },
      dialogVisible () {
        this.diaFlag=false
        this.Btndisabled=true
        this.dioName=''
        this.dioBtn='新增'
      },
      valueTime () {
        this.specificTime=""
      }


    },
    computed: {

      virtualDeviceList () {
        var data=this.$store.unitStore.getters.getUnitTree
        return isempty(data)? []:[unitList(data)]
      },
      dataList () {
        var data=this.$store.unitStore.getters.getUnitTree
        return isempty(data)? []:[unitList(data)]
      },
    },
    mounted () {
      // this.bbb()
      // this.handleData()
      $(() => {luckysheet.create(this.options);}); /*渲染*/
      // GetExcelTemplateDirectorieXlsx().then(res => {
      if(!isempty(this.dataList)) {
        this.defaultUnitId=this.dataList[0].id
      }
      statementAppTypeGroup().then(res => {
        // console.log("类型",res);
        if(res.code==200) {
          this.screenTypeData=res.data
        }
      })
      this.statementFindTreeFun()

      // this.treeList  = this.makeTree([res.Response]); 
      // })
    },
    methods: {
      //转换列定义名称
      transName (name) {
        if(name=='avgValue') {
          return "平均值"
        } else if(name=='maxValue') {
          return "最大值"
        } else if(name=='maxValueTime') {
          return "最大值时间"
        } else if(name=='minValue') {
          return "最小值"
        } else if(name=='minValueTime') {
          return "最小值时间"
        } else {
          return name
        }
      },
      //单元格宽度(根据字符来确定宽度)
      dynamicWidth (str) {
        return str.length>7? 8*str.length:70
      },
      //查询(表格数据)
      queryExcel_fn () {
        console.log(this.radio);
        if(this.specificTime=='') {
          this.$message({message: '请选择起始时间',type: 'warning'});
          return
        }
        if(this.radio==3) {

          this.$message({message: '请选择值类型',type: 'warning'});
          return
        }

        var sheet=luckysheet.getAllSheets()[0]
        sheet.config['columnlen']={}
        console.log("sheet",sheet);
        var accordArr=sheet.celldata.filter(item => item.c==this.Onecolumn)
        var newAccordArr=accordArr.filter(item => item.v.hasOwnProperty('ps'))
        var minVal=Math.min.apply(Math,newAccordArr.map(item => item.r))
        var a=[]
        newAccordArr.forEach(item => {
          a.push(item.v.ps.value)
        })
        if(a.length==0) {
          this.$message({message: '请添加变量再获取数据',type: 'warning'});
          return
        }
        var d={
          'beginTime': new Date(this.specificTime).getTime(),
          'dateType': this.valueTime,
          'stepValue': 1,
          'valueType': this.radio,
          'variables': a
        }
        statementVariableData(d).then(res => {
          if(res.code==200) {
            Object.keys(res.data).forEach((key,index) => {
              // console.log(newAccordArr[index],key,res.data[key]); 
              if(newAccordArr[index].v.ps.value==key) {
                Object.keys(res.data[key]).forEach((item,i) => {
                  // console.log("表头",item);

                  sheet.celldata.push({
                    "r": minVal-1,
                    "c": newAccordArr[index].c+i,
                    "v": {
                      "bg": "#6fa8dc",
                      "ct": {
                        "fa": "General",
                        "t": "s"
                      },
                      "fs": 11,
                      "ff": "宋体",
                      "bl": 1,
                      "ht": 0,
                      "vt": 0,
                      "tb": 1,
                      "v": this.transName(item),
                      "qp": 1,
                    }
                  })
                  sheet.celldata.push({
                    "r": newAccordArr[index].r,
                    "c": newAccordArr[index].c+i,
                    "v": {
                      "ct": {
                        "fa": "General",
                        "t": "s"
                      },
                      "fs": 10,
                      "ff": "宋体",
                      "bl": 0,
                      "ht": 0,
                      "vt": 0,
                      "tb": 1,
                      "v": res.data[key][item],
                      "qp": 1,
                    }
                  })
                  // sheet.celldata[].v['bg'] =  "#6fa8dc"
                  sheet.config.columnlen[`${newAccordArr[index].c+i}`]=this.dynamicWidth(res.data[key][item])

                })

              }

            })
            window.luckysheet.destroy();
            this.options.data=[sheet];
            window.luckysheet.create(this.options);

          }

        })
        // for(let k in res.data){
        // 	console.log(k,res.data[k]);
        // }
        // exportSheetExcel(luckysheet.getluckysheetfile(), "报表名称");
      },
      //点击设备列表树形结构
      handleNodeClick (data) {
        // var a = data.Content.variableName
        var a=data.Content.hasOwnProperty('variableName')

        this.treeClickCount++

        if(this.treeClickCount>2) return

        setTimeout(() => {
          // console.log(data.Content.variableName);
          var sheet=luckysheet.getAllSheets()[0]
          // console.log(sheet);
          var b=sheet.luckysheet_select_save
          var r=b[0].row[0]
          var c=b[0].column[0]

          var flag=true
          var d={
            "r": r,
            "c": c,
            "v": {
              "ct": {
                "fa": "General",
                "t": "s"
              },
              "fs": 10,
              "ff": "宋体",
              "bl": 0,
              "ht": 0,
              "vt": 0,
              "tb": 1,
              "v": "",
              "qp": 1,
              'ps': {
                "height": null,
                "isshow": false,
                "left": null,
                "top": null,
                "value": data.Content.variableName,
                "width": null
              }
            }
          }
          if(this.treeClickCount==2) {
            // 进行双击事件处理
            if(a) {
              if(r==0) {
                this.$message({message: '变量不可添加在第一行',type: 'warning'});
                this.treeClickCount=0
                return
              }
              this.dataOneConunt++
              sheet.celldata.forEach((item,index) => {
                // console.log(item);
                if(item.r==r&&item.c==c) {
                  // console.log("有相同需要替换",index);
                  sheet.celldata.splice(index,1)
                }

                if(item.v.hasOwnProperty('ps')) {
                  if(item.v.ps.value==data.Content.variableName) {
                    // console.log("1213",data.Content.variableName);
                    flag=false
                  }
                }

              })
              if(!flag) {
                this.$message({message: '变量已存在，请勿重复添加',type: 'warning'});
                this.treeClickCount=0
                return
              }
              sheet.celldata.push(d)
              window.luckysheet.destroy();
              this.options.data=[sheet];
              window.luckysheet.create(this.options);
              if(this.dataOneConunt<2) {
                this.Onecolumn=c
              }
            }

          }
          this.treeClickCount=0
        },300)


      },
      //弹窗按钮操作
      diaBtnFun (type) {
        if(type=='add') {
          this.diaFlag=true
          this.dioBtn='新增'
          this.dioName=""
        } else if(type=='edit') {
          this.diaFlag=true
          this.dioBtn='修改'
          this.dioName=""
        } else if(type=='del') {

          if(this.treeName=='') {
            this.$message({message: '请选择需要删除的目录或者数据节点',type: 'warning'});
            return
          }
          this.$confirm(`是否删除此${this.treeName}`,'提示',{
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            statementDeleteById({'id': this.recordId}).then(res => {
              if(res.code==200) {
                this.statementFindTreeFun()
                this.$message({message: '删除成功',type: 'success'});
              } else {
                this.$message({message: `删除失败,${res.message}`,type: 'error'});
              }
            })

          }).catch(() => {
            // ...
          });;
        } else if(type=='save') {
          this.diaFlag=true
          this.dioBtn='保存'
          this.dioName=""

        }
      },

      //子节点懒加载
      loadNode (node,resolve) {
        if(node.level===0) {
          return resolve([{temName: '请新建目录'}]);
        }
        if(node.level>2) return resolve([]);
        statementfindDataByCatalogueId({'id': node.data.id}).then(res => {
          if(res.code==200) {
            resolve(res.data);
          } else {
            this.$message({message: `获取失败,${res.message}`,type: 'warning'});
          }
        })
      },

      //弹窗输入框右边按钮
      inputBtn (type) {
        if(this.dioName=='') {
          this.$message({message: '请输入名称',type: 'warning'});
          return
        }
        // if(type == '新增'){

        // }
        var d={}
        if(type=='新增') {


          if(this.recordList.length==0) {
            d={
              "content": "",
              "dataType": 0,
              "parentId": 0,
              "temName": this.dioName,
              "uid": 0
            }
          } else {
            d={
              "content": "",
              "dataType": 0,
              "parentId": this.recordList[0].id,
              "temName": this.dioName,
              "uid": 0
            }
          }
        } else if(type=='修改') {
          d={
            "content": "",
            "dataType": 0,
            "parentId": this.recordList[0].id,
            "temName": this.dioName,
            "uid": this.recordId
          }
        } else if(type==='保存') {
          var a=luckysheet.getAllSheets()
          var id=0
          if(this.dataFlag) {
            var id=this.dataTypeId
          }
          d={
            "content": JSON.stringify(a[0]),
            "dataType": 1,
            "parentId": this.recordId,
            "temName": this.dioName,
            "uid": id
          }

        }
        console.log("传参",d);
        statementSave(d).then(res => {
          console.log("新增",res);
          if(res.code==200) {
            this.dioName=""
            this.$message({message: `${type}成功`,type: 'success'});
            this.statementFindTreeFun()
          } else {
            this.$message({message: `${type}失败,${res.message}`,type: 'warning'});
          }
        })
      },
      //弹窗树形结构被点击
      diaTreeClick (a) {
        console.log(a);
        this.Btndisabled=false
        this.treeName=a.temName
        if(a.dataType==1) { //第三级也就是数据
          this.dataFlag=true
          this.dataTypeId=a.id
          this.dioName=a.temName

        } else {
          this.dataFlag=false
          this.recordId=a.id
          this.dioName=''
        }
        if(this.dioBtn=='修改') {
          this.dioName=a.temName
        }
      },
      //根据id获取目录树
      statementFindTreeFun () {
        statementFindTree().then(res => {
          if(res.code==200) {
            this.recordList=res.data
          }
        })
      },
      //点击操作记录选项卡
      recordFun () {
        this.activeIndex=2
        this.statementFindTreeFun()
      },
      //操作记录树形结构
      recordTreeClick (node) {
        console.log(node);
        this.leftRecordId=node.id
        this.leftRecordName=node.temName
      },
      //查询(操作记录)
      queryExcel_fn1 () {
        if(this.leftRecordId=='') {
          this.$message({message: `请选择操作记录`,type: 'warning'});
          return
        }
        var aaa=[]
        statementFindById({"id": this.leftRecordId}).then(res => {

          if(res.code==200) {
            if(res.data==null) {
              this.$message({message: `请选择操作记录`,type: 'warning'});
              return
            }
            if(res.data.content!='') {
              aaa.push(JSON.parse(res.data.content))
              console.log(aaa);
              window.luckysheet.destroy();
              this.options.data=aaa;
              window.luckysheet.create(this.options);
            } else {
              this.$message({message: `此${this.leftRecordName}报表暂无数据`,type: 'warning'});
            }
          }

        })
        // exportSheetExcel(luckysheet.getluckysheetfile(), "报表名称");
      },

      //导出
      downloadExcel () {
        // console.log("luckysheet.getluckysheetfile()",luckysheet.getluckysheetfile());
        // console.log("luckysheet.getAllSheets()",luckysheet.getAllSheets());
        luckysheet.sheetmanage.getGridData(luckysheet.flowdata)
        exportExcel(luckysheet.getluckysheetfile(),"报表名称");
        //   exportExcel(luckysheet.getAllSheets(),"下载")


      },
      //导入
      uploadExcel (evt) {
        const files=evt.target.files;
        console.log("files",files);
        if(files==null||files.length==0) {
          alert("No files wait for import");
          return;
        }

        let name=files[0].name;

        let suffixArr=name.split("."),suffix=suffixArr[suffixArr.length-1];
        if(suffix!="xlsx") {
          alert("Currently only supports the import of xlsx files");
          return;
        }
        LuckyExcel.transformExcelToLucky(files[0],function(exportJson,luckysheetfile) {
          console.log("exportJson",exportJson);
          if(exportJson.sheets==null||exportJson.sheets.length==0) {
            alert("Failed to read the content of the excel file, currently does not support xls files!");
            return;
          }
          window.luckysheet.destroy();

          window.luckysheet.create({
            container: 'luckysheet', //luckysheet is the container id
            showinfobar: false,
            data: exportJson.sheets,
            title: exportJson.info.name,
            userInfo: exportJson.info.name.creator
          });
        });
      },
      //导入
      demoHandler (e) {
        console.log(1123);
        var vue=this;
        LuckyExcel.transformExcelToLucky(document.querySelector('#Luckyexcel-demo-file').files[0],
          (exportJson,luckysheetfile) => {
            if(exportJson.sheets==null||exportJson.sheets.length==0) {
              vue.$alert(
                "无法读取excel文件的内容，当前不支持xls文件！"
              );
              return;
            }
            console.log("exportJson.sheets",exportJson.sheets);
            window.luckysheet.destroy();
            vue.options.data=exportJson.sheets;
            window.luckysheet.create(vue.options);
          }
        );
      },
      //新增（查询）
      addExcel_fn () {

        // var b = tagsView.state.ccc;
        // b[0].name = this.enterpriseName
        // b[0].celldata[0].v.v = new Date(this.demonstrationYear).getFullYear() + '年' + '('+this.enterpriseName+')'
        // window.luckysheet.destroy();
        // this.options.data = b;
        // window.luckysheet.create(this.options);
        // if(this.enterpriseName=='-- 选择企业 --'){
        // 	 this.$message({ showClose: true, message: "请选择企业", type: 'warning'});
        // 	 return
        // }
        this.dialogVisible=true
        this.statementFindTreeFun()

      },
      //树形结构选中节点
      currentChecked (nodeObj,SelectedObj) {
        // console.log(SelectedObj);
        // console.log(SelectedObj.checkedKeys);  // 这是选中节点的key数组
        // console.log(SelectedObj.checkedNodes);  // 这是选中节点数组
        this.checkedNodes=SelectedObj.checkedNodes
        this.checkedNodes.forEach((item,index) => {
          if(item.Content.hasOwnProperty('variableName')) {
            // console.log(item.Content.variableName);
          } else {
            this.checkedNodes.splice(index,1)
          }
        })
        this.halfCheckedNodes=SelectedObj.halfCheckedNodes
        this.halfCheckedNodes.splice(0,1)

      },

      //树形结构筛选
      filterNode (value,data) {
        if(!value) return true;
        // console.log(data.Content.Name.indexOf(value) !== -1);
        return data.Content.Name.indexOf(value)!==-1;
        // return data.Content.Name == value;
      },
      //类型筛选
      screenType_fn (value) {
        var a=JSON.parse(JSON.stringify(this.treeListCopy))
        a.forEach(item => {
          // console.log(item.ChildDatas);
          item.ChildDatas.forEach(t => {
            // console.log(t.ChildDatas);
            t.ChildDatas=t.ChildDatas.filter(v => v.Content.Id==value)
            // if(t.ChildDatas.length == 0){
            // 	console.log("查找",t.ChildDatas);

            // }

          })
        })
        this.treeList=a

        // this.treeList.push(a[0])

      },
      //批量添加
      baobiao () {
        var sheet=luckysheet.getAllSheets()[0]
        // console.log(sheet);
        var flag=true
        var b=sheet.luckysheet_select_save
        var r=b[0].row[0]
        var c=b[0].column[0]
        // console.log("c",c);
        if(r==0) {
          this.$message({message: '变量不可添加在第一行',type: 'warning'});
          return
        }

        if(this.checkedNodes.length==0) {
          this.$message({message: '请选择变量',type: 'warning'});
          return
        }
        this.checkedNodes.forEach((item,index) => {
          sheet.celldata.forEach((t,i) => {
            // console.log(item);
            if(t.r==r+index&&t.c==c) {
              // console.log("有相同需要替换",index);
              sheet.celldata.splice(i,1)
            }
            if(t.v.hasOwnProperty('ps')) {
              if(t.v.ps.value==item.Content.variableName) {

                flag=false

              }
            }
          })
          // console.log("123",item.Content.variableName);
          if(!flag) {
            return
          }
          sheet.celldata.push({
            "r": r+index,
            "c": c,
            "v": {
              "ct": {
                "fa": "General",
                "t": "s"
              },
              "fs": 10,
              "ff": "宋体",
              "bl": 0,
              "ht": 0,
              "vt": 0,
              "tb": 1,
              "v": "",
              "qp": 1,
              'ps': {
                "height": null,
                "isshow": false,
                "left": null,
                "top": null,
                "value": item.Content.variableName,
                "width": null
              }
            }
          })

        })
        if(!flag) {
          this.$message({message: '变量已存在，请勿重复添加',type: 'warning'});
          return
        }
        this.dataOneConunt++
        window.luckysheet.destroy();
        this.options.data=[sheet];
        window.luckysheet.create(this.options);
        if(this.dataOneConunt<2) {
          this.Onecolumn=c
        }
      },
      //把树形结构的数据渲染到excel表格
      // baobiao(){
      // //   console.log(luckysheet.getAllSheets()[0].luckysheet_select_save);
      // 	this.halfCheckedNodes.forEach(item => {
      // 		item.Content.num = 0
      // 	})
      //   var b = JSON.parse(JSON.stringify(tagsView.state.ccc));

      //   let arr = []
      // 	let num = 0
      // 	this.checkedNodes.forEach((item,index) => {
      // 		if(!item.ChildDatas){
      //              arr.push({
      // 					"r": 2,
      // 					"c": 2,
      // 					"v": {
      // 						"ct": {
      // 						"fa": "General",
      // 						"t": "s"
      // 						}, 
      // 						"fs": 14,
      // 						"ff": "宋体",
      // 						"bl": 0,
      // 						"ht": 0,
      // 						"vt": 0,
      // 						"tb": 1,
      // 						"v": item.Content.Name,
      // 						"qp": 0
      // 					 }
      // 					})
      // 			// console.log(item.Content.Name.indexOf("益大") !== -1);
      //             this.halfCheckedNodes.forEach(t => {
      // 					if(item.Content.variableName.indexOf(t.Content.Name) !== -1){
      // 						t.Content.num += 1
      // 					}
      // 			})
      // 			num += 1
      // 		}
      // 	})

      // 	arr.forEach((item,index) => {
      // 		item.r = 3+index
      // 	})
      //     this.options.row = num<50? 50:num+3

      // 	 console.log("this.halfCheckedNodes",this.halfCheckedNodes);
      // 	console.log("表格数据",b);
      // 	b[0].celldata = b[0].celldata.concat(arr)
      // 	this.halfCheckedNodes.forEach((item,index) => {
      // 		// console.log(index,item);
      // 		if(item.Id){
      // 			if(index ==0 ){
      // 			b[0].config.merge[`3_1`] = {
      // 							"rs": item.Content.num,//合并多少行
      // 							"cs": 1,//合并多少列
      // 								"r": 3,
      // 						"c": 1
      // 							}
      // 		   b[0].celldata.push({
      // 							"r": 3,
      // 							"c": 1,
      // 							"v": {
      // 							"ct": {
      // 								"fa": "General"
      // 							},
      // 							"fs": 12,
      // 							"ff": "宋体",
      // 							"bl": 1,
      // 							"ht": 0,
      // 							"vt": 0,
      // 							"v":item.Content.Name,
      // 							"tb": 1
      // 							}
      // 						})
      // 		}else {
      // 			console.log("item.Content.num",this.halfCheckedNodes[index-1].Content.num);
      // 			b[0].config.merge[`${3+this.halfCheckedNodes[index-1].Content.num}_1`] = {
      // 							"rs": item.Content.num,//合并多少行
      // 							"cs": 1,//合并多少列
      // 								"r": 3,
      // 						     "c": 0
      // 							}
      // 			b[0].celldata.push({
      // 							"r":`${3+this.halfCheckedNodes[index-1].Content.num}`,
      // 							"c": 1,
      // 							"v": {
      // 							"ct": {
      // 								"fa": "General"
      // 							},
      // 							"fs": 12,
      // 							"ff": "宋体",
      // 							"bl": 1,
      // 							"ht": 0,
      // 							"vt": 0,
      // 							"v":item.Content.Name,
      // 							"tb": 1
      // 							}
      // 						})
      // 		   }

      // 		}

      // 	})

      // 	b[0].name = this.enterpriseName
      // 	b[0].celldata[0].v.v = new Date(this.demonstrationYear).getFullYear() + '年' + '('+this.enterpriseName+')'
      // 	b[0].config.merge['3_0'].rs = num
      // 	window.luckysheet.destroy();
      // 	this.options.data = b;
      // 	window.luckysheet.create(this.options);

      // },
      //选择企业
      enterpriseNodeClick (a) {
        this.enterpriseName=a.label
        this.enterpriseID=a.id
        this.treeList=[]
        this.shouMenu=false
        statementVariableTree({"unitId": this.enterpriseID}).then(res => {
          // console.log("数据",res);
          if(res.code==200) {

            // this.treeList.push(res.data) 
            this.handleData(res)
          }

        })

      },
      //处理企业数据
      handleData (data) {
        console.log("a",data);

        //  this.departmentData =   JSON.parse(JSON.stringify(this.departmentData).replace(/appTypes/g, 'ChildDatas').replace(/groupName/g, "Name").replace(/groupId/g, "Id"))
        data=JSON.parse(JSON.stringify(data).replace(/appTypes/g,'ChildDatas').replace(/groupName/g,"Name").replace(/groupIdAndName/g,"Content").replace(/groupId/g,"Id").replace(/appTypeInfo/g,"Content").replace(/appName/g,"Name"))
        data.data.ChildDatas.forEach(item => {
          item.ChildDatas=item.Content.groups
          item.Content.num=0

        })
        this.treeList.push(data.data)
        console.log("树形结构",this.treeList);
        this.treeListCopy=this.treeList
      },


      //查询
      onSubmit (v) {
        this.$refs['search'].validate((valid) => {
          if(valid) {
            var vue=this;
            var d={
              path: this.value2,
              date: this.search.date? parseTime(this.search.date,"{y}-{m}-{d} {h}:{i}:{s}"):parseTime(new Date(),"{y}-{m}-{d} {h}:{i}:{s}"),
              isAfferentTime: this.search.isAfferentTime
            };
            axios({
              url: '/api/ExcelReport/GetExcelTemplateBuildFileXlsx',
              method: 'post',
              data: d,
              responseType: 'arraybuffer'
            })
              .then(function(response) {
                if(v==1) {//判断查询
                  LuckyExcel.transformExcelToLucky(
                    response.data,
                    (exportJson,luckysheetfile) => {
                      if(exportJson.sheets==null||exportJson.sheets.length==0) {
                        vue.$alert(
                          "无法读取excel文件的内容，当前不支持xls文件！"
                        );
                        return;
                      }
                      window.luckysheet.destroy();
                      vue.options.data=exportJson.sheets;
                      window.luckysheet.create(vue.options);
                    }
                  );
                } else {//下载 

                  const blob=new Blob([response.data],{type: "application/vnd.ms-excel"});

                  const link=document.createElement('a');
                  link.href=URL.createObjectURL(blob);
                  link.download=vue.search.name;
                  link.click();
                  URL.revokeObjectURL(link.href);
                }
              })
              .catch(err => {
                GetExcelTemplateDirectorieXlsx();
              })
          } else {
            return false;
          }
        });
      },
      //测试
      bbb () {
        // var b = this.$store.state.tagsView.aaa;
        tagsView.mutations.modifyData()
        var b=tagsView.state.ccc;
        // console.log("表格数据",b);
        // b[0].name = "修改"
        window.luckysheet.destroy();
        this.options.data=b;
        window.luckysheet.create(this.options);
      },
      //点击赋值
      assignment (v,n,id) {
        this.thisId=id;
        this.$set(this.search,'name',n);
        this.value2=v+'\\'+n;
      },
      //先根据id和parentId的关系生成关系树
      makeTree (arr) {
        var temp=[];
        if(arr) {
          for(var i=0;i<arr.length;i++) {
            if(arr[i].FileNames.length>1) {
              arr[i].FileNames.map((v,ie) => {
                if(ie>0) {
                  arr.push({
                    FileNames: [v],
                    Path: arr[ie]&&arr[ie].Path||arr[0]&&arr[0].Path
                  })
                }
              })
            }
            temp.push(arr[i]);
            arr[i].Childs=this.makeTree(arr[i].Childs);
          }
          return temp;
        }
      },


    },

  };
</script>

<style scoped lang="scss">
  .active {
    background-color: #409eff;
    color: #fff;
  }

  /deep/.is-checked+.custom-tree-node {
    background-color: #fff !important;
    color: #606266 !important;
  }

  .home {
    box-sizing: border-box;
    padding: 10px;
    background: #eaecf0;
  }

  /deep/.el-dialog {
    width: 22%;
  }

  .specific-timer {
    /deep/.el-input__icon {
      line-height: 30px;
    }
  }

  /deep/.el-select {
    width: 80px;
  }

  .dia-input {
    display: flex;
    justify-content: center;
    margin-top: 10px;

    input {
      width: 280px;
      margin-right: 10px;
    }
  }

  .btnss {
    padding-bottom: 10px;
    border-bottom: 1px solid #ccc;
  }

  .switch {
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    margin-bottom: 20px;

    div {
      width: 50%;
      height: 100%;
      text-align: center;
      line-height: 40px;

      cursor: pointer;

      &.active {
        background-color: #409eff;
        color: #fff;
      }
    }
  }

  .select-enterprise {
    width: 90%;
    height: 30px;
    border: 1px solid #898989;
    display: flex;
    align-items: center;
    justify-content: center;

  }

  .lefted {
    position: relative;
  }

  .el-icon-d-arrow-left {
    position: absolute;
    right: 0;
    top: 300px;
    z-index: 1;
    font-size: 28px;
    cursor: pointer;
    background: #d7d7d7;
    clip-path: polygon(-18px 35px,
        26px 100%,
        calc(100% - 1px) 100%,
        calc(100% - 0px) 0);
    height: 70px;
    line-height: 70px;
    color: #666;
  }

  /deep/.el-input__inner {
    height: 30px;
  }

  /deep/.el-select__caret {
    line-height: 25px;
  }

  .el-icon-d-arrow-right {
    position: absolute;
    left: 0;
    top: 300px;
    z-index: 1;
    font-size: 28px;
    cursor: pointer;
    background: #d7d7d7;
    clip-path: polygon(0 0,
        1px 100%,
        calc(100% - 26px) 100%,
        calc(100% - -27px) 31px);
    height: 70px;
    line-height: 70px;
    color: #666;
  }

  .screen-type {
    margin: 10px 0;

    display: flex;
    justify-content: center;

    /deep/.el-select {
      width: 90%;
    }

  }

  .unitMenu {
    max-width: 4rem;
    height: 4rem;
    margin-left: .1rem;
    top: 0;
    padding-top: .4rem;
    position: absolute;
    z-index: 99999;
  }

  .unitMenu .readDeviceTreeBody {
    border-width: 1px;
    border-style: solid;
    border-radius: 0 0 10px 10px;
  }

  .righted {
    box-sizing: border-box;
    position: relative;
    min-height: calc(100vh - 150px);
    background: #fff;
    border-left: 10px solid #eaecf0;
    padding: 10px;
  }

  // /deep/.el-tree-node:focus>.el-tree-node__content {
  //    background-color: #409eff;
  // }
  .choice {
    margin-bottom: 25px;

    /deep/.el-input__inner {
      height: 25px;
    }

    /deep/.el-icon-date {
      line-height: 25px;
    }

    .surface-type {
      display: flex;
      align-items: center;
      margin-bottom: 4px;

      .type {
        width: 137px;
      }

      .timer {
        margin: 0px 20px;
      }

      // /deep/.el-input {
      // 	width: 40%;
      // }


    }

    .column-type {
      margin-top: 4px;
      display: flex;
      align-items: center;

    }
  }

  .demo-form-inline {
    position: relative;
    margin-top: 5px;
    z-index: 1;
  }

  .search {
    padding: 10px;
    display: block;
    padding-right: 25px;
    position: relative;
  }

  .is-checked+.custom-tree-node {
    background: #409eff;
    color: #fff;
  }

  .home {
    height: 100%;
  }

  .home .el-tree {
    overflow-y: scroll;
    left: 0;
    bottom: 0;
    height: 100%;
    min-height: 400px;
    width: 100%;
  }



  .websvg_box {
    display: block;
    overflow: scroll;
    width: 100%;
  }



  .wrapper {
    width: 100%;
    height: 500px;
  }

  .pagination_box {
    display: flex;
    justify-content: flex-end;
    margin-top: 5px;
  }
</style>